import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

export const removeNilKeys = <T = object>(o: object): T => {
    return omitBy(o, isNil) as unknown as T;
};
